import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Event } from '../communication/model/event.model';
import { events } from './data/event-list.source';
@Injectable()
export class ReportService {
  
  constructor(private http: HttpClient) { }

  public getEvents(crawfordRef: string): Observable<Event[]> {
    return of(events);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/report/report.service.ts